import { useNavigate, useParams } from 'react-router'
import { useFetcher } from '../utils/fetcher'
import { WebsiteConfigBM } from '@bm-js/atlascloud-shared'
import { useActions, useToast } from '../utils/hooks'
import { pDelay } from '@naturalcycles/js-lib/promise'
import { ROUTE } from '../cnst/router.cnst'

export const useEditorApi = () => {
  const fetcher = useFetcher()
  const { triggerRebuild } = useActions()
  const { id } = useParams()
  const toast = useToast()
  const navigate = useNavigate()

  const saveConfig = async (websiteConfig: WebsiteConfigBM) => {
    const { err } = await fetcher({
      path: `customer/website/${id}`,
      method: 'POST',
      body: { websiteConfig },
    })
    if (err) toast.error('Ändringarna kunde inte sparas')
    else toast.success('Ändringarna sparades')
  }

  const publishConfig = async (websiteConfig: WebsiteConfigBM) => {
    const { err } = await fetcher({
      path: `customer/website/publish/${id}`,
      method: 'POST',
      body: { websiteConfig },
    })
    if (err) toast.error('Publiceringen misslyckades')
    else toast.success('Publiceringen lyckades')
    await triggerRebuild()
    await pDelay(500)
    toast.info('Sidan uppdateras, det kan ta ett par minuter')
    await navigate(ROUTE.DASHBOARD)
  }

  return { saveConfig, publishConfig }
}
